import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=798ca082&"
var script = {}
import style0 from "./NoResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798ca082')) {
      api.createRecord('798ca082', component.options)
    } else {
      api.reload('798ca082', component.options)
    }
    module.hot.accept("./NoResult.vue?vue&type=template&id=798ca082&", function () {
      api.rerender('798ca082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/NoResult.vue"
export default component.exports